import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { isSafePath } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import { cancelAppointmentConfirmationScreenEvent } from "../../../../../../../../../data-layer/v3/data-layer/actions.js";
import { useRoutingContext } from "../../../../../../../context/RoutingContext/v3/pages/CancelAppointment/context/RoutingContext/context.js";
import CancelAppointmentConfirmation from "./CancelAppointmentConfirmation.js";
import { useCancelAppointmentContext } from "../../../../../../../context/v3/pages/CancelAppointment/context/context.js";
import { AppointmentCommunicationChannel } from "../../../../../../../../../types/v3/types/shared.js";
import { fromArrayToString } from "../../../../../../../../../utils/v3/utils/from-array-to-string.js";
const CancelAppointmentConfirmationContainer = () => {
  const { appointment, store } = useCancelAppointmentContext();
  const { getLabel, getFormattedLabel } = useIntl();
  const [
    ,
    {
      queryParams: { returnPath, returnLabel }
    }
  ] = useRoutingContext();
  const labels = React.useMemo(
    () => ({
      title: getFormattedLabel("appointments.page.cancel.confirm.title", {
        labelData: { name: appointment?.invitee?.firstName ?? "" }
      }),
      subtitle: getLabel("appointments.page.cancel.confirm.subtitle"),
      notification: appointment?.preferredChannelOfCommunication === AppointmentCommunicationChannel.EMAIL ? getLabel(`appointments.page.cancel.confirm.notification.email`) : getLabel("appointments.page.cancel.confirm.notification.sms"),
      returnLabel: getLabel("appointments.page.cancel.confirm.closeButtonLabel.backHome")
    }),
    [appointment, getLabel, getFormattedLabel]
  );
  React.useEffect(() => {
    if (appointment && store) {
      const dataLayerEvent = cancelAppointmentConfirmationScreenEvent({
        appointment: {
          startTime: appointment.startTime,
          endTime: appointment.endTime,
          appointmentType: {
            id: appointment.appointmentType?.id || "",
            ageGroup: appointment.appointmentType?.ageGroup ?? "ADULT"
          }
        },
        store
      });
      DataLayer.pushEvent(dataLayerEvent);
    }
  }, [appointment, store]);
  if (!appointment) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    CancelAppointmentConfirmation,
    {
      labels,
      appointment,
      store,
      returnLabel: fromArrayToString(returnLabel) ?? labels.returnLabel,
      returnPath: (() => {
        const rawReturnPath = fromArrayToString(returnPath) ?? "/";
        return isSafePath(rawReturnPath) ? rawReturnPath : "/";
      })()
    }
  );
};
export {
  CancelAppointmentConfirmationContainer as default
};
//# sourceMappingURL=CancelAppointmentConfirmationContainer.js.map
